var map = {
	"./basketball.webp": 15200,
	"./dpe.webp": 47798,
	"./gym.webp": 7502,
	"./indoorstadium.webp": 75823,
	"./indoorstadium_inside.webp": 91980,
	"./kabadi.webp": 25037,
	"./playground.webp": 72890,
	"./tabletennis.webp": 21890,
	"./track.webp": 22722,
	"./volleyball.webp": 4439,
	"./volleyball2.webp": 95495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67797;